import { ComponentProps } from 'react';
import { useHasPermissions, useHasUIFeatures } from './has-permissions.hook';
import { PermissionBoundary } from './permission-boundary.component';

export function usePermissionsBoundary({
  availableUiFeatures,
  permissions,
  onlyRequireSomePermissions
}: Pick<
  ComponentProps<typeof PermissionBoundary>,
  'availableUiFeatures' | 'permissions' | 'onlyRequireSomePermissions'
>) {
  const permissionChecks = permissions || [];
  const featureChecks = availableUiFeatures || [];

  const permissionResult = useHasPermissions(permissionChecks);
  const featureResult = useHasUIFeatures(featureChecks);

  const isLoading =
    (permissionChecks.length > 0 && permissionResult.isLoading) ||
    (featureChecks.length > 0 && featureResult.isLoading);

  const rejectPredicates = [
    permissionChecks.length > 0 && permissionResult.hasSomePermissions !== true,
    permissionChecks.length > 0 && !onlyRequireSomePermissions && permissionResult.hasAllPermissions !== true,
    featureChecks.length > 0 && featureResult.hasAllFeatures === false
  ];

  return {
    isLoading,
    isRejected: rejectPredicates.some((predicate) => predicate === true)
  };
}
